import { Injectable } from '@angular/core';
import {
  ComboGroup, ComboGroupStructure, DisplayedAllergenGroup,
  DisplayedProduct,
  DisplayedSize,
  GecoPosMenu,
  Group,
  ModifierGroup, ModifierGroupType,
  OverridePositionsMap,
  Product,
  RelatedProductsProgram,
  Size, TagDto,
} from 'app/models/menu.model';
import { getComboElementKey, MenuOverrideService } from 'app/services/menu-override.service';
import { MenuState } from 'app/reducers/menu.reducer';

@Injectable({
  providedIn: 'root'
})
export class MenuConverter {
  constructor(
  ) {
  }

  public convertMenu(
    gecoPosMenu: GecoPosMenu,
    overridePositionsMap: OverridePositionsMap,
    menuBackups: Map<string, GecoPosMenu>)
    : MenuState
  {
    const originalDictionaryGroups = new Map<string, Group>();
    const dictionaryProducts = new Map<string, DisplayedProduct>();
    const originalDictionaryProducts = new Map<string, Product>();
    const dictionarySizes = new Map<string, DisplayedSize>();
    const originalDictionarySizes = new Map<string, Size>();
    const dictionaryModifierGroups = new Map<string, ModifierGroup>();
    const originalDictionaryModifierGroups = new Map<string, ModifierGroup>();
    const dictionaryComboGroups = new Map<string, ComboGroup>();
    const originalDictionaryComboGroups = new Map<string, ComboGroup>();
    const originalDictionaryAllergenGroup = new Map<string, DisplayedAllergenGroup>();
    const dictionaryAllergenGroup = new Map<string, DisplayedAllergenGroup>();
    const dictionaryTags = new Map<string, TagDto>();
    const originalDictionaryTags = new Map<string, TagDto>();
    const modifierGroupTypesDictionary = new Map<string, ModifierGroupType>();
    const originalDictionaryRpProgram = new Map<string, RelatedProductsProgram>();
    const dictionaryRpProgram = new Map<string, RelatedProductsProgram>();

    for (let originalGroup of gecoPosMenu.groups) {
      originalDictionaryGroups.set(originalGroup.externalId, originalGroup);
    }

    const dictionaryGroups = MenuOverrideService.overrideMenu(originalDictionaryGroups, overridePositionsMap);

    let comboGroupStructures: ComboGroupStructure[] = [];

    for (const product of gecoPosMenu.products) {
      originalDictionaryProducts.set(product.externalId, product);
      dictionaryProducts.set(product.externalId, MenuOverrideService.overrideProduct(product, overridePositionsMap));

      if (product.comboStructure?.groups && product.comboStructure.groups.length){
        comboGroupStructures = [...comboGroupStructures, ...product.comboStructure.groups];
      }
    }

    comboGroupStructures.forEach(comboGroupStructure => {
      comboGroupStructure.products.forEach(comboElement => {
        const comboElementId = getComboElementKey(comboGroupStructure.comboGroupId, comboElement.externalProductId);
        const product= originalDictionaryProducts.get(comboElement.externalProductId);
        const copyProduct = {...product, externalId: comboElementId};
        dictionaryProducts.set(comboElementId, MenuOverrideService.overrideProduct(copyProduct, overridePositionsMap));
      });
    });

    for (const size of gecoPosMenu.sizes) {
      originalDictionarySizes.set(size.externalId, size);
      dictionarySizes.set(size.externalId, MenuOverrideService.overrideSize(JSON.parse(JSON.stringify(size)), overridePositionsMap));
    }
    for (const modifierGroup of gecoPosMenu.modifierGroups) {
      originalDictionaryModifierGroups.set(modifierGroup.externalId, modifierGroup);
      dictionaryModifierGroups.set(modifierGroup.externalId, MenuOverrideService.overrideModifierGroup(JSON.parse(JSON.stringify(modifierGroup)), overridePositionsMap));
    }
    for (const comboGroup of gecoPosMenu.comboGroups) {
      originalDictionaryComboGroups.set(comboGroup.externalId, comboGroup);
      dictionaryComboGroups.set(comboGroup.externalId, MenuOverrideService.overrideComboGroup(JSON.parse(JSON.stringify(comboGroup)), overridePositionsMap));
    }
    for(const allergenGroup of gecoPosMenu.allergenGroups) {
      originalDictionaryAllergenGroup.set(allergenGroup.externalId, allergenGroup);
      dictionaryAllergenGroup.set(allergenGroup.id, MenuOverrideService.overrideAllergenGroups(JSON.parse(JSON.stringify(allergenGroup)), overridePositionsMap));
    }
    for (const tag of gecoPosMenu.tags) {
      originalDictionaryTags.set(tag.id, tag);
      dictionaryTags.set(tag.id, MenuOverrideService.overrideTags({...tag}, overridePositionsMap));
    }
    if(gecoPosMenu.modifierGroupTypes){
      for (const mgt of gecoPosMenu.modifierGroupTypes) {
        modifierGroupTypesDictionary.set(mgt.id, mgt);
      }
    }
    if(gecoPosMenu.relatedProductsPrograms){
      for(const rpProgram of gecoPosMenu.relatedProductsPrograms) {
        originalDictionaryRpProgram.set(rpProgram.id, rpProgram);
        dictionaryRpProgram.set(rpProgram.id, MenuOverrideService.overrideRelatedProductsProgram(JSON.parse(JSON.stringify(rpProgram)), overridePositionsMap))
      }
    }
    return {
      dictionaryGroups: dictionaryGroups,
      originalDictionaryGroups: originalDictionaryGroups,
      dictionaryProducts: dictionaryProducts,
      originalDictionaryProducts: originalDictionaryProducts,
      dictionarySizes: dictionarySizes,
      originalDictionarySizes: originalDictionarySizes,
      dictionaryModifiersGroups: dictionaryModifierGroups,
      originalDictionaryModifiersGroups: originalDictionaryModifierGroups,
      dictionaryComboGroup: dictionaryComboGroups,
      originalDictionaryComboGroup: originalDictionaryComboGroups,
      dictionaryAllergenGroup: dictionaryAllergenGroup,
      originalDictionaryAllergenGroup: originalDictionaryAllergenGroup,
      dictionaryTags: dictionaryTags,
      originalDictionaryTags: originalDictionaryTags,
      menuBackups: menuBackups,
      dictionaryModifierGroupTypes: modifierGroupTypesDictionary,
      dictionaryRpProgram: dictionaryRpProgram,
      originalDictionaryRpProgram: originalDictionaryRpProgram,
    } as MenuState;
  }
}
